import $ from 'jquery';
import Plyr from 'plyr';


function videoBlock() {
  $('.video-block:not(.video-block--popup) .video').each(function () {
    const videoElement = $(this).get(0)
    let poster = $(this).data('poster');
    let autoplay = $(this).hasClass('video--autoplay');
    let block = $(this);
    if ($(this).hasClass('video--oembed')) {
      const player = new Plyr(videoElement, {
        controls: autoplay ? false : ['play-large'],
        autoplay: autoplay,
        vimeo: { autoplay: true, loop: true, trasparent: true, background: true },
        youtube: { autoplay: autoplay },
        fullscreen: { enabled: autoplay },
        loop: { active: true }
      })

      player.on('ready', event => {
        let video = block.find('.plyr__video-embed__container');
        let bannerInner = block;
        function videoSize() {
          var $windowHeight = bannerInner.height();
          var $videoHeight = video.outerHeight();
          var $scale = $windowHeight / $videoHeight;
          if ($videoHeight <= $windowHeight) {
            video.attr('style',
              "-webkit-transform:scale(" + $scale + ") translateY(0%)!important; transform:scale(" + $scale + ") translateY(0%)!important"
            );
          };
        }
        videoSize();
        $(window).on('load resize', function () {
          videoSize();
        });
      });

      // Customize the Plyr controls
      player.on('ready', () => {

        $('.btn-close').on('click', function () {
          player.pause()
        })
        $('.modal').on('click', function (event) {
          // Check if the click occurred outside of .modal-content
          if (!$(event.target).closest('.modal-content').length) {
            player.pause()
          }
        })

        $('.video').on('click touchstart', function (event) {
          event.preventDefault()
          event.stopPropagation()
          if (player.paused) {
            player.play()
          } else {
            player.pause()
          }
        })


      })
      if (autoplay) {
        player.play();
        player.muted = true;
      }
      if (poster) player.poster = poster;
      return player
    } else {
        let player = new Plyr($(this).get(0), {
          controls: autoplay ? false : ['play-large'],
          autoplay: autoplay,
          vimeo: { autoplay: autoplay },
          youtube: { autoplay: autoplay },
          fullscreen: { enabled: autoplay }
        });
        $('.video').on('click touchstart', function (event) {
          event.preventDefault()
          event.stopPropagation()
          if (player.paused) {
            player.play()
          } else {
            player.pause()
          }
        })

        $(window).on("load", function () {
          if (autoplay) {
            player.muted = true;
            player.play()
          }
        });

        if (poster) player.poster = poster;
        return player;
    }
  })
}


function videoBlockPopup() {
  $('.video-block.video-block--popup .video').each(function () {
    const videoElement = $(this).get(0)
    let poster = $(this).data('poster');
    let player = false;
    if ($(this).hasClass('video--oembed')) {
      player = new Plyr(videoElement, {
        controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume'],
        autoplay: false,
        vimeo: { autoplay: false },
        youtube: { autoplay: false },
        fullscreen: { enabled: false }
      })

      if (poster) player.poster = poster;
      //return player
    } else {
      player = new Plyr($(this).get(0), {
        controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume'],
        autoplay: false,
        vimeo: { autoplay: false },
        youtube: { autoplay: false },
        fullscreen: { enabled: false }
      });
      if (poster) player.poster = poster;
      //return player;
    }
    // Customize the Plyr controls
    player.on('ready', () => {

      $('.popup-close').on('click', function () {
        player.pause()
      })
      $('.popup').on('click', function (event) {
        // Check if the click occurred outside of .modal-content
        if (!$(event.target).closest('.popup-content').length) {
          player.pause()
        }
      })

      $('.video').on('click touchstart', function (event) {
        event.preventDefault()
        event.stopPropagation()
        if (player.paused) {
          player.play()
        } else {
          player.pause()
        }
      })


    })
  })
}

function videoPopup() {
  let $videoPopup = $('#video-popup');
  $(document).on("click", ".js-video-popup" , function ( e) {
    e.preventDefault();
    var videoSrc = $(this).data("video");
    var videoType = $(this).data("type"); // 'file' or 'iframe'
    var videoPoster = $(this).data("poster");
    var videoAutoplay = $(this).data("autoplay")? true : false;
    var popupContent = $videoPopup.find(".video-block");

    // Clear any previous video content
    popupContent.html("");

    var videoElement;
    if (videoType === "file") {
      // Local video file (MP4, WebM)
      let videoAttrs = videoAutoplay ? 'autoplay muted loop playsinline' : 'controls';
      videoElement = `
              <video class="video" ${videoAttrs}>
                  <source src="${videoSrc}" type="video/mp4">
              </video>
          `;
    } else {
      // YouTube or Vimeo iframe embed
      videoElement = `
              <div class="video">
                  <iframe src="${videoSrc}?autoplay=0&modestbranding=1&rel=0" 
                          allowfullscreen allow="autoplay"></iframe>
              </div>
          `;
    }

    // Insert video element inside popup
    popupContent.html(videoElement);

    // Initialize Plyr
    let player = new Plyr(popupContent.find('.video').get(0), {
      controls: videoAutoplay?['play-large']:['play-large' ,'play', 'progress', 'current-time', 'mute', 'volume' ],
      autoplay: videoAutoplay,
      vimeo: { autoplay: videoAutoplay },
      youtube: { autoplay: videoAutoplay },
      fullscreen: { enabled: videoAutoplay }
    });
    if (videoPoster) player.poster = videoPoster;

    $videoPopup.fadeIn();
    player.on('ready', () => {
      player.play();

      $videoPopup.find('.popup-close').on('click', function () {
        player.pause()
      })
      $videoPopup.on('click', function (event) {
        // Check if the click occurred outside of .modal-content
        if (!$(event.target).closest('.popup-content').length) {
          player.pause()
        }
      })
    });
  });

}

function imagePopup() {
  let $image_popup = $('#image-popup');
  $(document).on("click", ".js-image-popup" , function ( e) {
    e.preventDefault();
    var image_src = $(this).attr("src");
    var popupContent = $image_popup.find(".image-block");

    // Clear any previous video content
    popupContent.html("");

    var imageElement = `
            <img src="${image_src}" alt="image">
        `;

    // Insert image element inside popup
    popupContent.html(imageElement);
    $image_popup.fadeIn();
  });

}

export { videoBlock, videoBlockPopup, videoPopup , imagePopup };
